<template>

  <Teleport to="body">
<div v-if="this.id" class="modal fade" tabindex="-1"  role="document" :id="this.id">
    <div class="modal-dialog  modal-dialog-scrollable  modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">

          <template v-if="isLoading"> Carregando... </template>

          <template v-else>
            <span v-if="showAllPages"> {{ pageCount }} página(s) </span>

            <span v-else>
              <button class="btn btn-sm btn-light-primary  m-1"
                      data-toggle="tooltip"
                      title="Página anterior"
                      :disabled="page <= 1"
                      @click="page--">
                <i class="bi bi-arrow-up-circle"></i>
              </button>

              <label class="m-4">
                {{ page }} / {{ pageCount }}
              </label>

              <button class="btn btn-sm btn-light-primary m-1"
                      :disabled="page >= pageCount"
                      @click="page++"
                      data-toggle="tooltip"
                      title="Próxima página">
                <i class="bi bi-arrow-down-circle"></i>
              </button>

            </span>

            <label class="right m-4">
              <input v-model="showAllPages" type="checkbox" />
              Mostrar todas
            </label>

            <button class="btn btn-sm btn-light-primary m-1" data-toggle="tooltip" title="Imprimir" @click="printDoc()">
              <i class="bi bi-printer"></i>
            </button>

            <button class="btn btn-sm btn-light-primary m-1" data-toggle="tooltip" title="Fazer download" @click="downloadDoc()">
              <i class="bi bi-download"></i>
            </button>

            <span v-if="signed"
                  class="badge fw-bolder text-right mx-2 p-2"
                  :class="signed??false ? 'badge-light-success' : 'badge-light-warning'">
              <i class="bi bi-pen-fill badge-light-success ms-2 me-2"></i> Assinado Digitalmente
            </span>

          </template>

          <button type="button" class="btn-close" aria-label="Fechar" data-bs-dismiss="modal"></button>

        </div>

        <div class="modal-body">
          <vue-pdf-embed
            ref="pdfRef"
            :source="source"
            :page="page"
            width="1100"
            @password-requested="handlePasswordRequest"
            @rendered="handleDocumentRender"
          />
        </div>

        <div v-if="delivery" class="pdf-delivery">
          <template v-if="entregasConfirmadas.length">
            <i class="bi bi-send"></i>
            <span>
              Ao finalizar o atendimento, será enviado <strong>{{ entregasConfirmadas.join(' e ') }}</strong>.
              <template v-if="contatosFaltando.length">
                Falta {{ contatosFaltandoTexto }} no cadastro para enviar também por {{ canaisFaltandoTexto }}.
              </template>
            </span>
          </template>
          <template v-else>
            <i class="bi bi-exclamation-triangle"></i>
            <span>O paciente <strong>não vai receber</strong> estes documentos: não há {{ contatosFaltando.map((f) => f.contato).join(' nem ') }} no cadastro dele.</span>
          </template>

          <button v-if="delivery.canEdit && contatosFaltando.length" type="button" class="btn btn-sm btn-light-primary"
                  @click="$emit('edit-contact')">
            Informar {{ contatosFaltandoTexto }}
          </button>
        </div>

      </div>

    </div>
  </div>
  </Teleport>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed';
import Download from "../../../helpers/download";

export default {
  components: {
    VuePdfEmbed
  },
  emits: ['edit-contact'],
  props: {
    id: String,
    pdfSource: String,
    fileName: String,
    signed: Boolean,
    /**
     * Para onde o documento vai depois da consulta. Nulo esconde a faixa — nem
     * todo uso do visualizador é de documento que será enviado.
     */
    delivery: {
      type: Object,
      default: null,
    },
  },
  computed: {
    entregasConfirmadas() {
      const canais = [];

      if (this.delivery?.email) {
        canais.push(`por e-mail para ${this.delivery.email}`);
      }

      if (this.delivery?.whatsapp_enabled && this.delivery?.whatsapp) {
        canais.push(`por WhatsApp para ${this.delivery.whatsapp}`);
      }

      return canais;
    },
    contatosFaltando() {
      if (!this.delivery) {
        return [];
      }

      const faltando = [];

      if (!this.delivery.email) {
        faltando.push({canal: 'e-mail', contato: 'e-mail'});
      }

      // O WhatsApp so entra na conta onde o local ligou o aviso: cobrar um
      // telefone que nao seria usado de nada so atrapalha.
      if (this.delivery.whatsapp_enabled && !this.delivery.whatsapp) {
        faltando.push({canal: 'WhatsApp', contato: 'telefone'});
      }

      return faltando;
    },
    contatosFaltandoTexto() {
      return this.contatosFaltando.map((f) => f.contato).join(' e ');
    },
    canaisFaltandoTexto() {
      return this.contatosFaltando.map((f) => f.canal).join(' e ');
    },
  },
  data() {
    return {
      isLoading: true,
      page: null,
      pageCount: 1,
      showAllPages: true,
      source: '',
    }
  },
  mounted() {
    this.pageCount = 0;
  },
  watch: {
    showAllPages() {
      this.page = this.showAllPages ? null : 1;
    },
    pdfSource(newPdfSource, oldPdfSource) {
      if (newPdfSource !== oldPdfSource) {
        this.source = newPdfSource;
      }
    },
  },
  methods: {
    handleDocumentRender(args) {
      this.isLoading = false;
      this.pageCount = this.$refs.pdfRef.pageCount;
    },
    handlePasswordRequest(callback, retry) {
      callback(prompt(retry ? 'Insira a senha novamente' : 'Insira a senha'));
    },
    downloadDoc() {
      let pos = this.pdfSource.indexOf(",")
      Download.base64File('application/pdf', this.pdfSource.substring(pos+1, this.pdfSource.length), this.fileName);
    },
    printDoc() {
      // Converte base64 para blob
      const base64Data = this.pdfSource.split(',')[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      // Cria iframe para impressão
      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '0';
      iframe.style.bottom = '0';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);

      iframe.src = blobUrl;

      iframe.onload = function() {
        setTimeout(() => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        }, 500);
      };

      // Limpa quando a janela de impressão for fechada
      window.addEventListener('focus', function cleanup() {
        setTimeout(() => {
          if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
            URL.revokeObjectURL(blobUrl);
          }
          window.removeEventListener('focus', cleanup);
        }, 500);
      }, { once: true });
    },
  }
}
</script>

<style scoped>
.pdf-delivery {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #eef0f2;
  background: #f8f9fa;
  font-size: 0.85rem;
  color: #4b5675;
}

.pdf-delivery i {
  font-size: 1rem;
  color: #7e8299;
}

.pdf-delivery span {
  flex: 1;
}

.fixedHeader
{
  position:fixed;
}
</style>